import styled from 'styled-components'

import type React from 'react'

interface ModalProps {
  /** 对话框是否可见 */
  visible?: boolean
  /** 关闭时销毁 Modal 里的子元素 */
  destroyOnHidden?: boolean
  /** 对话框标题 */
  title?: string
  /** 对话框宽度 */
  width?: number | string
  /** 对话框高度 */
  height?: number | string
  /** 对话框内边距 默认20px */
  padding?: number | string
  /** 对话框内容 */
  children?: React.ReactNode
  /** 内容样式*/
  bodyClassName?: string
  /** 关闭 Modal */
  onClose?: () => void
}

const Overlay = styled.div<{ open?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  display: ${({ open }) => (open ? 'block' : 'none')};

  width: 100vw;
  height: 100vh;

  background: rgba(0, 0, 0, 0.5);
`

const Content = styled.div<{
  width?: number | string
  height?: number | string
  $padding?: number | string
}>`
  position: relative;

  display: flex;
  flex-direction: column;

  margin: 10% auto;
  padding: ${({ $padding }) =>
    typeof $padding === 'number' ? `${$padding}px` : $padding || '20px'};

  box-sizing: border-box;

  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width || '80%')};
  height: ${({ height }) => (typeof height === 'number' ? `${height}px` : height || '80%')};

  background: white;
  border-radius: 24px;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`

const Title = styled.h3`
  margin: 0 0 16px;
`

const CloseButton = styled.span`
  position: absolute;
  top: 12px;
  right: 14px;

  display: inline-block;
  width: 24px;
  height: 24px;

  font-size: 24px;
  cursor: pointer;
  color: #999;

  text-align: center;
  line-height: 22px;

  &:hover {
    color: rgba(0, 0, 0, 0.88);
    background-color: rgba(0, 0, 0, 0.06);
  }
`

export const Modal: React.FC<ModalProps> = ({
  visible,
  onClose,
  title = '弹窗',
  width,
  height,
  bodyClassName = '',
  padding,
  children,
  destroyOnHidden
}) => {
  if (!visible && destroyOnHidden) return null

  return (
    <Overlay open={visible}>
      <Content $padding={padding} className={bodyClassName} height={height} width={width}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Title>{title}</Title>
        {children}
      </Content>
    </Overlay>
  )
}
